import { render } from "./CustomerInfoPane.vue?vue&type=template&id=12c1eef8"
import script from "./CustomerInfoPane.vue?vue&type=script&lang=js"
export * from "./CustomerInfoPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__